module.exports = "/assets/62714fd2ee9167d3c497b4e2c5fe5e1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/LI.png
// module id = 1580
// module chunks = 0